/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttributeGroupsAg } from '../../models/attribute-groups-ag';

export interface GetAttributeTypeMasterData$Params {
  orid: number;
}

export function getAttributeTypeMasterData(http: HttpClient, rootUrl: string, params: GetAttributeTypeMasterData$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AttributeGroupsAg>>> {
  const rb = new RequestBuilder(rootUrl, getAttributeTypeMasterData.PATH, 'get');
  if (params) {
    rb.path('orid', params.orid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AttributeGroupsAg>>;
    })
  );
}

getAttributeTypeMasterData.PATH = '/api/MetaModel/attributeTypeDropdown/{orid}';
